module.exports = __webpack_public_path__ + "img/googlePlayBg.28949025.png";